import { ActionButton, DefaultButton, MessageBar, MessageBarType, PrimaryButton, Stack } from '@fluentui/react';
import * as React from 'react';

interface IEventPropertiesImageViewProps {
    eventId: number;
    fileButtonClick: () => void;
    imageChaged: (event: React.ChangeEvent<HTMLInputElement>) => void;
    IconUrl: any;
    loadImage: () => void;
}


export const EventPropertiesImageView: React.FunctionComponent<IEventPropertiesImageViewProps> = (props) => {

    React.useEffect(() => {
        props.loadImage();
    }, [])
    return (
        <Stack>
            <Stack horizontalAlign="center">
                <ActionButton iconProps={{
                    iconName: "add"
                }} allowDisabledFocus checked={false} disabled={props.eventId === 0} onClick={props.fileButtonClick}>
                    Vyber soubor
                </ActionButton>
                {
                    (props.eventId === 0 ? <MessageBar messageBarType={MessageBarType.info}>Nejprve prosím uložte typ události a po té přidejte obrázek</MessageBar> : null)
                }
                <input id="hiddenFileInput" type="file" onChange={props.imageChaged} style={{ display: "none" }} accept="image/png, image/gif, image/jpeg" />

                <img src={props.IconUrl} style={{ maxWidth: 200 }} onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "/img/noimageicon.png";
                }} />
            </Stack>

            
</Stack>    )
}
